/* eslint-disable import/first */
import React from 'react';
import { Drawer } from '@material-ui/core';
import { GrClose } from '@react-icons/all-files/gr/GrClose';
import css from './index.module.scss';
import classNames from 'classnames';
export default function DrawerPwa({
  variant,
  anchor,
  open,
  onClose,
  children,
  hideCloseButton,
  extraClass,
}) {
  return (
    <Drawer className={css.root} variant={variant} anchor={anchor} open={open}>
      {!hideCloseButton && (
        <div className={css.closeButton} onClick={onClose}>
          <GrClose size=".8em" />
        </div>
      )}
      <div className={classNames(css.content, { [extraClass]: extraClass })}>{children}</div>
    </Drawer>
  );
}
